
function mostRecentFirst(a, b) {
  return new Date(b) - new Date(a);
}
function oldestFirst (a, b) {
  return new Date(a) - new Date(b);
}
// sorts an array of objects on passed property. most recent first
export function dateSort (arrData, prop, order=1) {
  var byDate = arrData.slice(0);
  if (order === 1)
    byDate.sort(function(a,b) { return mostRecentFirst(a[prop],b[prop]) });
  else
    byDate.sort(function(a,b) { return oldestFirst(a[prop],b[prop]) });
  return byDate;
}
export function dateObjSort (arrData, prop) {
  arrData.sort(function(a,b) {return (a[prop]??0)-(b[prop]??0)})
}
// removes all but the first occurance of prop from array of objects
export function firstFilter (arrData, prop) {
  const unique = arrData.filter ((item, index, self) => 
    index === self.findIndex((t) => (
      t[prop] === item[prop]
    )))
  return unique;
}

export function lastFilter (arrData, prop) {
  arrData.reverse();
  const unique = firstFilter(arrData, prop);
  return unique;
}

// sort by time, then filter non-first device ids
export function mostRecentFilter (jsonResponse) {
  const arrWorking = jsonResponse.data.raw_data;
  const byDate = dateSort(arrWorking, "ReadTime");
  const unique = firstFilter(byDate, "DeviceId");
  return {data: {raw_data: unique}}
}
